import cn from  './cn'
import en from './en'
import de from  './de'

export default {
    cn,
    en,
    de
}
